import { createBrowserRouter } from "react-router-dom";
import Home from "../pages/Home";
import RouteNames from "./type";
import CreateClaim from "../pages/CreateClaim";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: RouteNames.CREATE_CLAIM,
    element: <CreateClaim />,
  },
]);
